export const REGISTER_GOOGLE = 'REGISTER_GOOGLE';

export const registerGoogle = {
    type: REGISTER_GOOGLE
};



// WEBPACK FOOTER //
// ./src/actions/AppHeaderAction.js